import { GlobalCss } from './styles'
import Rotas from './routes'
import Cart from './components/Cart'

function App() {
  return (
    <>
      <GlobalCss />
      <Rotas />
      <Cart />
    </>
  )
}

export default App
